module.exports = __webpack_public_path__ + "static/media/img-1.a9fb12d3.png";